import styled from "styled-components";
import {
  AppBar} from "@mui/material";

export const StyledAppBar = styled(AppBar)`
  border-top: 5px ${props => props.theme.palette.secondary.main} solid ;
  width: 100%;
`;
export const Logo = styled.img`
    max-width: 250px;
  margin: 10px 0 0 0;
`;

export const FooterImage = styled.img`
  width: 150px;
  position: absolute;
  top: -90px;
`;
